import React from "react";
import { useSelector } from "react-redux";
import { LANDSCAPE } from "../../../config/Constant";
import IFrameRendererHome_Landscape from "./iFrameRendererHome_landscape";
import IFrameRendererHome_Potrait from "./iFrameRendererHome_potrait";



export const IFrameRendererHome = (props) => {
    const { appOrientation } = useSelector(state => (state.appConfigSlice));

    if (appOrientation == LANDSCAPE) {
        return <IFrameRendererHome_Landscape {...props} />;
    } else {
        return <IFrameRendererHome_Potrait {...props} />;
    }
}

